import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DatasetOption } from '@dxo/ng-swift-ui';
import { Subscription } from 'rxjs';
import { PortalTimeoutService } from '../../services/portal-timeout/portal-timeout.service';

@Component({
  selector: 'app-portal-timeout-modal',
  templateUrl: './portal-timeout-modal.component.html',
  styleUrls: ['./portal-timeout-modal.component.scss']
})
export class PortalTimeoutModalComponent implements OnInit, OnDestroy {
  showModal = false;
  timeInterval!: ReturnType<typeof setInterval>;
  timeoutSubscription = new Subscription();
  logoutDataset: DatasetOption = {
    selector: 'button,div',
    data: {
      name: 'TimeoutLogout'
    }
  };

  @Input() countdownTimeSeconds = 0;
  @Output() logout = new EventEmitter<Event>();

  private sessionExpiresAt: Date | undefined;

  formattedTime = '2:00';

  get remainingTimeMilliseconds(): number {
    if (!this.sessionExpiresAt) {
      return this.countdownTimeSeconds * 1000;
    }

    return this.sessionExpiresAt?.getTime() - new Date().getTime();
  }

  constructor(private timeoutService: PortalTimeoutService) {}

  ngOnInit(): void {
    this.formatTime();
    this.timeoutSubscription = this.timeoutService.timeoutSubject.subscribe(() => {
      this.initiateCountdown();
      this.showModal = true;
    });
  }

  ngOnDestroy(): void {
    this.timeoutSubscription.unsubscribe();
  }

  initiateCountdown(): void {
    this.sessionExpiresAt = new Date(new Date().getTime() + this.countdownTimeSeconds * 1000); // current time + 2m
    this.timeInterval = setInterval(() => {
      if (this.remainingTimeMilliseconds > 0) {
        this.formatTime();
      } else {
        clearInterval(this.timeInterval);
        this.logoutUser();
      }
    }, 1000);
  }

  formatTime(): void {
    const remainingMilliseconds = this.remainingTimeMilliseconds;
    if (remainingMilliseconds <= 0) {
      this.formattedTime = '0:00';
    }

    const remainingMinutes = Math.floor(remainingMilliseconds / 1000 / 60);
    const remainingSeconds = Math.floor(remainingMilliseconds / 1000) % 60;
    this.formattedTime = `${remainingMinutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  onClose(): void {
    this.showModal = false;
    this.formattedTime = '2:00';
    clearInterval(this.timeInterval);
  }

  logoutUser(): void {
    this.logout.emit();
  }
}
